import React from "react";

import styles from "./index.scss";

export default function globalLoader() {
  return (
    <div id="wbk-GlobalLoader" className={styles["wbk-GlobalLoader-Container"]}>
      <div className={styles["wbk-GlobalLoader-Loader"]}>
        <svg className={styles["wbk-GlobalLoader-Circular"]} viewBox="25 25 50 50">
          <circle
            className={styles["wbk-GlobalLoader-Path"]}
            cx="50"
            cy="50"
            r="20"
            fill="none"
            strokeWidth="2"
            strokeMiterlimit="10"
          />
        </svg>
      </div>
    </div>
  );
}
